import { Component, OnDestroy, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { Router } from '@angular/router';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Offcanvas } from 'bootstrap';
import { ConnectedUser } from '../shared/connected-user';
import { Subscription } from 'rxjs';
import { UserSessionService } from '../user-session.service';


@Component({
  selector: 'app-homeuser',
  templateUrl: './homeuser.component.html',
  styleUrls: ['./homeuser.component.css'],
  standalone: false
})
export class HomeuserComponent implements OnInit, OnDestroy {
  email: string;
  pincode: string;
  pincodeRetaitPro: string;
  pincodeRetait: string;
  entreprise: FormGroup;
  loader: boolean = false;
  sucessMessage: boolean = false;
  baccountList: any[];
  caissierForm: FormGroup;
  lastname: string;
  firstname: string;
  primaryaccountnumber: string;
  primaryaccountSolde: string;
  isEditVitrine: boolean;
  vitrineid: any;
  sucessMessageEdit: boolean = false;
  sigle: string;
  codePro: Object;
  nombreDeCompteMax: number;
  islimit: boolean;
  CNINotConfirm: boolean;
  phoneNotConfirm: boolean;
  secure: boolean = false;
  confirmphone: boolean = false;
  confirmCNi: boolean = false;
  connectedUser: ConnectedUser | null = null;
  get displayPrimaryAccountNumber(): string {
    return (this.connectedUser?.primaryAccountNumber ?? this.primaryaccountnumber ?? '').toString();
  }
  get displayPrimaryAccountBalance(): number | string {
    return this.connectedUser?.primaryAccountBalance ?? this.primaryaccountSolde ?? 0;
  }
  stepIndex = 0;
  offcanvasRef: Offcanvas;
  readonly stepFields = [
    ['nomEntreprise', 'numero'],
    ['nomGestionnaire', 'prenomGestionaire', 'telephoneGestionnaire'],
    ['ville', 'quartier', 'typ'],
    []
  ];
  readonly stepLabels = ['Entreprise', 'Gestionnaire', 'Localisation', 'Validation'];
  private userSessionSubscription?: Subscription;



  constructor(
    private userService: PayService,
    private router: Router,
    private userSessionService: UserSessionService
  ) {

  }

  ngOnInit(): void {
    this.userSessionSubscription = this.userSessionService.changes().subscribe(user => {
      if (user) {
        this.applyConnectedUser(user);
      }
    });

    this.ngBussinessAccount();
    this.initUtilisateurInformations();

  }
  ngOnDestroy(): void {
    this.userSessionSubscription?.unsubscribe();
  }
  ngBussinessAccount() {
    this.entreprise = new FormGroup(
      {
        telephoneGestionnaire: new FormControl('', [Validators.required, Validators.pattern('(^(65)[0-9]{1}[0-9]{6}|^(69|66|67)[0-9]{7})$')]),
        nomEntreprise: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(30)]),
        nomGestionnaire: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(25)]),
        prenomGestionaire: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(25)]),
        ville: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(25)]),
        quartier: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(25)]),
        numero: new FormControl('', [Validators.required, Validators.minLength(14), Validators.maxLength(14)]),
        typ: new FormControl('', [Validators.required])
      });
  }
  initUtilisateurInformations() {
    const sessionUser = this.userSessionService.getUser();
    if (sessionUser) {
      this.applyConnectedUser(sessionUser);
      this.getBussnessAccount();
      return;
    }

    // Essaye d'abord le cache local (connecté via login)
    const cached = localStorage.getItem('connectedUser');
    if (cached) {
      try {
        const u = JSON.parse(cached) as ConnectedUser;
        this.userSessionService.setUser(u);
        this.applyConnectedUser(u);
        this.getBussnessAccount();
        //this.baccountList = this.connectedUser.businessAccounts ?? [];
      } catch { /* ignore parse errors */ }
    }
  }
  getBussnessAccount() {
    if (!this.connectedUser?.username) {
      return;
    }

    this.userService.getAllUtilisateurBaccount(this.connectedUser.username)
      .subscribe((data: any[]) => {
        if (!data || data.length == null) {
          return;
        }
        console.log(data);
        this.nombreDeCompteMax = data.length;
        this.baccountList = data;

        // ✅ Sync avec connectedUser + localStorage
        this.syncConnectedUserBusinessAccounts(data);
      });
  }
  removeAccount(id: any) {
    this.userService.removeBaccount(id).subscribe(() => {
      this.getBussnessAccount(); // va aussi mettre à jour le localStorage maintenant
    });
  }

  private syncConnectedUserBusinessAccounts(accounts: any[]) {
    if (!this.connectedUser) {
      this.connectedUser = this.userSessionService.getUser();
    }

    if (this.connectedUser) {
      this.userSessionService.setUser({
        ...this.connectedUser,
        businessAccounts: accounts
      });
      this.connectedUser = this.userSessionService.getUser();
    }
  }

  private applyConnectedUser(user: ConnectedUser) {
    this.connectedUser = user;
    this.firstname = user.firstname ?? this.firstname;
    this.lastname = user.lastname ?? this.lastname;
    this.confirmphone = user.confirmphone ?? this.confirmphone;
    this.confirmCNi = user.confirmCNi ?? this.confirmCNi;
    this.secure = user.secure ?? this.secure;

    if (user.primaryAccountNumber) {
      this.primaryaccountnumber = String(user.primaryAccountNumber);
    }
    if (user.primaryAccountBalance !== undefined) {
      this.primaryaccountSolde = String(user.primaryAccountBalance);
    }
    if (user.primaryAccountSigle) {
      this.sigle = user.primaryAccountSigle;
    }
  }


  getpincode() {
    this.userService.getPincodePourAchat(this.connectedUser.username).subscribe(code => {
      switch (code) {
        case -11:
          this.CNINotConfirm = true;
          setTimeout(() => this.CNINotConfirm = false, 3000);
          break;
        case -10:
          this.phoneNotConfirm = true;
          setTimeout(() => this.phoneNotConfirm = false, 3000);
          break;
        default:
          this.pincode = String(code);
      }
    });
  }

  getpincodeRetrait() {
    this.userService.getPincodeRetrait(this.connectedUser.username).subscribe(code => {
      switch (code) {
        case -11:
          this.CNINotConfirm = true;
          setTimeout(() => this.CNINotConfirm = false, 3000);
          break;
        case -10:
          this.phoneNotConfirm = true;
          setTimeout(() => this.phoneNotConfirm = false, 3000);
          break;
        default:
          this.pincodeRetait = String(code);
      }
    });
  }

  getpincodeRetraitProfessionel(_i: any, baccountid: string) {
    this.userService.getPinretraitBussness(baccountid).subscribe(code => {
      const str = code.toString(); // <--- convertit proprement

      const formatted = str.match(/.{1,3}/g)?.join(' ') ?? str;

      const target = document.getElementById(baccountid);
      if (target) {
        target.textContent = formatted;  // <-- plus safe que innerHTML
        target.classList.add('text-success');
      }
    });
  }


  editVitrine(b) {
    this.entreprise.patchValue({
      telephoneGestionnaire: b.telephoneGestionnaire,
      nomEntreprise: b.nomEntreprise,
      nomGestionnaire: b.nomGestionnaire,
      prenomGestionaire: b.prenomGestionaire,
      ville: b.ville,
      quartier: b.quartier,
      typ: b.typ,
      numero: b.numero,
    });
    this.isEditVitrine = true;
    this.vitrineid = b.id;
    this.stepIndex = 0;
    this.openProDrawer();
  }


  onSaveEntreprise(formData: any): void {
    const SHORT_DELAY = 3000;
    const LONG_DELAY = 6000;
    console.log("******************************************", formData);
    if (this.isEditVitrine) {
      // 🔹 Mode édition de vitrine
      this.loader = true;

      this.userService.UpdateUtilisateurBussnessAccount(formData, this.vitrineid)
        .subscribe((data: number) => {
          if (data === 0) {
            this.sucessMessageEdit = true;

            setTimeout(() => {
              this.sucessMessageEdit = false;
              this.getBussnessAccount();
              this.loader = false;
              $('#contact-tab').trigger('click');
              this.closeProDrawer();
            }, SHORT_DELAY);
          } else {
            // Autres codes possibles → logique inchangée (no-op)
          }
        });

    } else {
      // 🔹 Mode création de vitrine
      if (this.nombreDeCompteMax < 5) {
        this.loader = true;
        this.userService.addUtilisateurBussnessAccount(formData, this.connectedUser.username)
          .subscribe((resp: number) => {
            if (resp === 0) {
              this.sucessMessage = true;
              setTimeout(() => {
                this.sucessMessage = false;
                this.loader = false;
                this.getBussnessAccount();
                // $('#contact-tab').trigger('click'); // laissé commenté comme dans ton code
                this.closeProDrawer();
              }, LONG_DELAY);

            } else if (resp === -11) {
              this.CNINotConfirm = true;

              setTimeout(() => {
                this.CNINotConfirm = false;
                this.loader = false;
              }, SHORT_DELAY);

            } else if (resp === -10) {
              this.phoneNotConfirm = true;

              setTimeout(() => {
                this.phoneNotConfirm = false;
                this.loader = false;
              }, SHORT_DELAY);
            } else {
              // Autres codes → logique inchangée (no-op)
            }
          });

      } else {
        // 🔹 Limite de comptes atteinte
        this.islimit = true;

        setTimeout(() => {
          this.islimit = false;
        }, SHORT_DELAY);
      }
    }

    // 🔹 Remise à zéro de l'état de formulaire
    this.isEditVitrine = false;
    this.stepIndex = 0;
    // this.entreprise.reset();
  }






  GoToAddCaissier(accountname: string | number | boolean, accountid: string) {
    const safeName = encodeURIComponent(accountname);
    this.router.navigateByUrl("ajouter/caisier/" + safeName + "/" + accountid);
  }

  GoTobSpace(accountname: string | number | boolean, accountid: string) {
    localStorage.setItem("iscaissier", "false");
    localStorage.setItem("accountid", accountid);
    const safeName = encodeURIComponent(accountname);
    this.router.navigateByUrl("utilisateur/bspace");
  }
  GoTobSpaceTransaction(accountname: string | number | boolean, accountNumber: string) {
    const safeName = encodeURIComponent(accountname);
    this.router.navigateByUrl("utilisateur/espace/busnes/activite/" + safeName + "/" + accountNumber)
  }

  startCreate() {
    this.isEditVitrine = false;
    this.vitrineid = null;
    this.stepIndex = 0;
    this.entreprise.reset();
    this.openProDrawer();
  }

  openProDrawer() {
    const el = document.getElementById('offcanvasPro');
    if (el) {
      this.offcanvasRef = Offcanvas.getOrCreateInstance(el);
      this.offcanvasRef.show();
    }
  }

  closeProDrawer() {
    if (this.offcanvasRef) {
      this.offcanvasRef.hide();
    }
  }

  currentStepFields(): string[] {
    return this.stepFields[this.stepIndex] || [];
  }

  stepValid(): boolean {
    return this.currentStepFields().every(c => this.entreprise.get(c)?.valid);
  }

  touchCurrentStep() {
    this.currentStepFields().forEach(c => this.entreprise.get(c)?.markAsTouched());
  }

  nextStep() {
    this.touchCurrentStep();
    if (!this.stepValid()) return;
    if (this.stepIndex < this.stepLabels.length - 1) {
      this.stepIndex++;
    }
  }

  prevStep() {
    if (this.stepIndex > 0) {
      this.stepIndex--;
    }
  }

  progressPercent(): number {
    return (this.stepIndex / (this.stepLabels.length - 1)) * 100;
  }

  get nomEntreprise() { return this.entreprise.get('nomEntreprise'); }
  get telephoneGestionnaire() { return this.entreprise.get('telephoneGestionnaire'); }

}
